<template>
	<div id="container" style="    width: 100%;">
		<div  @scroll="handleScroll" class="scrollView">
			<a-spin :spinning="reloading">
				<div class="subscribe">
					<div style="padding-bottom:50px">
						<!--文章类别-->
						<div>
							<div class="custom-block">
								<text>已选用文章类别</text>
							</div>
							<div class="u-flex u-flex-wrap" style="   margin-top: 1rem;">
								<button style="margin:0.2rem" class="ubutton-class" :style="{
									border: 'none', 'color': item.checked == true ? '#2979ff' : '#606266',
									'border': item.checked == true ? '1px solid #a0cfff' : '', 'background-color': item.checked == true ? '#ecf5ff' : '#f9f7f7', 'padding': '0 20rpx', 'font-size': '25rpx',
									'height': ' 60rpx',
									'line-height': '60rpx'
								}" v-bind:key="index" :throttle-time="200" @click="tagCategoryClick(index)"
									v-for="(item, index) in parentCategories">{{ item.name }} <span
										v-if="item.checked == true">×</span></button>
							</div>
						</div>
						<div style="margin-top: 1rem;margin-bottom: 1rem;">
							<div style="position: relative">
								<div class="custom-block">
									<text>添加关键词</text>
								</div>
								<div style="   margin-top: 1rem;display: flex;align-items: center;">
									<a-input style="width: 80%;" v-model:value="keyword" placeholder='输入关键词'
										@change="onInput"></a-input>
									<a-button class=" inputView  " type="primary" @click="toAdd">
										<plus-outlined />添加
									</a-button>
								</div>
								<div class='searchView' v-if="searchList && searchList.length > 0">
									<div style="border: 1px solid #dcdfe6;padding:0px 10px 10px 10px">
										<div class="u-flex u-flex-wrap" style="   margin-top: 1rem;">
											<button style="margin:0.2rem" class="ubutton-class" :style="{
												border: 'none', 'background': '#f9f7f7', 'padding': '0 20rpx', 'font-size': '25rpx',
												'height': ' 60rpx',
												'line-height': '60rpx'
											}" v-bind:key="index" :throttle-time="200" @click="tagClick(2, item)" v-for="(item, index) in searchList">
												<template v-for="itemItem in item.searchName">
													<span v-if="itemItem.key == true" style='color:red'>{{ itemItem.str
													}}</span>
													<span v-else>{{ itemItem.str }}</span>
												</template>
											</button>
										</div>
									</div>
								</div>
							</div>
							<div style="margin-top: 1rem;margin-bottom: 1rem;">
								<div class="custom-block">
									<text>已订阅关键词</text>
								</div>
								<div class="u-flex u-flex-wrap" style="   margin-top: 1rem;">
									<button style="margin:0.2rem" class="ubutton-class" :style="{
										border: 'none', 'color': '#2979ff',
										'border': '1px solid #a0cfff', 'background-color': '#ecf5ff', 'padding': '0 20rpx', 'font-size': '25rpx',
										'height': ' 60rpx', 'padding': '0px 3px',
										'line-height': '60rpx'
									}" v-bind:key="index" :throttle-time="200" @click="tagClick(0, item)" v-for="(item, index) in selectList">{{
	item.name }} ×</button>
								</div>
							</div>
							<div class="custom-block">
								<text>推荐关键词</text>
							</div>
							<div class="u-flex u-flex-wrap" style="   margin-top: 1rem;">
								<button style="margin:0.2rem" class="ubutton-class" :style="{
									border: 'none', 'background': '#f9f7f7', 'padding': '0 20rpx', 'font-size': '25rpx',
									'height': ' 60rpx',
									'padding': '0px 3px', 'padding': '0px 3px',
									'line-height': '60rpx'
								}" v-bind:key="index" :throttle-time="200" @click="tagClick(1, item)" v-for="(item, index) in noList">{{
	item.name }}</button>
							</div>
						</div>
					</div>
				</div>
			</a-spin>
		</div>
		<div style="text-align:center">
			<a-button type="primary" @click="toSubmit">完成，立即查看情报</a-button>
		</div>
	</div>
	<!--<a-modal  v-model:visible="visible" :bodyStyle="{height:'90%',width:'500px'}">
     <iframe src="https://www.enplus.org.cn/vuePostertest/#/?id=129512&companyId=32&loading=true"></iframe>
  </a-modal>-->
	<a-modal centered width="20%" title="" v-model:visible="visible" :afterClose="afterClose" :closable="false"
		:footer="null">
		<div style="text-align: center;">
			<div style="    padding: 20px; 
					text-align: center;" @click="show = false">
				<div style="       font-size: 22px;
						display: flex;
						width: 100%;align-items:center;justify-content:center;">
					<check-circle-outlined v-if="num > 0" class="iconStyle success" />
					<exclamation-circle-outlined v-else class="iconStyle warning" />
					设置完成
				</div>
				<div v-if="num > 0" class="mr20">已更新{{ num }}篇情报</div>
				<div v-else class="mr20">您的订阅词匹配上的内容较少，建议您重新修改订阅词</div>
			</div>
			<div>
				<a-button @click="iKnow" type="primary">我知道了</a-button>
			</div>
		</div>
	</a-modal>
</template>
<script>
import { PlusOutlined, ExclamationCircleOutlined, CheckCircleOutlined } from "@ant-design/icons-vue";
import { hilight_str } from '../../untils/index'
import { reactive, watch, onMounted, ref } from 'vue'
import { getMiniKeywords, postSetMiniKeyword } from './js'
import store from '@/store'
import { message } from 'ant-design-vue/lib/components'
import router from "@/router";
export default {
	name: 'ticketPage',
	components: {
		PlusOutlined, ExclamationCircleOutlined, CheckCircleOutlined
	},
	setup() {
		watch(() => store.getters.company, (val) => {
			if (val && val != '') {
				var height = document.getElementById('container').offsetHeight
				scrollView.value = { height: (height - 60) + 'px', overflow: 'auto' }
			}
		})
		onMounted(() => {
			var height = document.getElementById('container').offsetHeight
			scrollView.value = { height: (height - 60) + 'px', overflow: 'auto' }
			toGetKeyword()
		})
		const scrollView = ref('')
		const scrollY = ref(0)
		const toGetKeyword = () => {
			reloading.value = true
			edit.value = false
			var keywordListList = []
			var i = 0
			getMiniKeywords({ companyId: store.getters.company.companyId }).then((res) => {
				var motherRecommendKeyword = toSplitKeyword(res.data.motherRecommendKeyword)
				var motherDefaultKeyword = toSplitKeyword(res.data.motherDefaultKeyword)
				var customKeyword = toSplitKeyword(res.data.customKeyword)
				var indexOf = res.data.parentCategories.findIndex(item => item.id == 55)
				var parentCategoriesList = []
				if (indexOf > -1) {
					res.data.parentCategories.splice(indexOf, 1)
					parentCategoriesList = res.data.parentCategories
				}
				parentCategoriesList = parentCategoriesList.map(x => { return { id: x.id, name: x.name, checked: false } })
				if (res.data.categoryIds) {
					childrenCategories.value = res.data.categoryIds.split("|")
					for (var i in childrenCategories.value) {
						if (childrenCategories.value[i] != 55)
							parentCategoriesList.find(item => item.id == childrenCategories.value[i]).checked = true
					}
				}
				else {
					parentCategoriesList = parentCategoriesList.map(x => { return { id: x.id, name: x.name, checked: true } })
				}
				parentCategories.value = parentCategoriesList
				for (i in motherDefaultKeyword) {
					keywordListList.push({
						name: motherDefaultKeyword[i],
						choose: false,
						default: true,
					})
				}
				for (i in motherRecommendKeyword) {
					keywordListList.push({
						name: motherRecommendKeyword[i],
						choose: false,
						default: true,
					})
				}
				for (i in customKeyword) {
					if (keywordListList.find(item => item.name == customKeyword[i])) {
						keywordListList.find(item => item.name == customKeyword[i]).choose = true
					}
					else {
						keywordListList.push({
							name: customKeyword[i],
							choose: true,
							default: false,
						})
					}
				}
				selectList.value = keywordListList.filter(item => item.choose == true)
				noList.value = keywordListList.filter(item => item.choose == false)
				keywordList.value = keywordListList
				reloading.value = false
			})
		}
		const toSplitKeyword = (val) => {
			if (val == '') return []
			else return val.split('|')
		}
		const childrenCategories = ref([])
		const parentCategories = ref([])
		const selectList = ref([])
		const noList = ref([])
		const keywordList = ref([])
		const edit = ref(false)
		const tagClick = (key, val) => {
			edit.value = true
			//0、已订阅关键词   1、推荐关键词   2、 输入框关键词
			var index = 0
			var list = []
			var result = null
			if (key == 0) {
				index = selectList.value.findIndex(item => item.name == val.name)
				selectList.value.splice(index, 1)
				if (val.default == false) {
					index = keywordList.value.findIndex(item => item.name == val.name)
					keywordList.value.splice(index, 1)
				}
				else {
					keywordList.value.find((item) => item.name == val.name).choose = false
					noList.value.push(keywordList.value.find((item) => item.name == val.name))
				}
			} else if (key == 1) {
				result = keywordList.value.find((item) => item.name == val.name).choose = true
				index = noList.value.findIndex(item => item.name == val.name)
				noList.value.splice(index, 1)
				selectList.value.push(keywordList.value.find((item) => item.name == val.name))
			}
			else {
				result = keywordList.value.find((item) => item.name == val.name).choose = true
				index = noList.value.findIndex(item => item.name == val.name)
				noList.value.splice(index, 1)
				selectList.value.push(keywordList.value.find((item) => item.name == val.name))
				keyword.value = ""
				searchList.value = []
			}
		}
		const keyword = ref('')
		const tagCategoryClick = (index) => {
			parentCategories.value[index].checked = !parentCategories.value[index].checked
		}
		const onInput = () => {
			if (keyword.value == '' || keyword.value.replaceAll(' ', '') == '') {
				keyword.value = ''
				searchList.value = []
			} else {
				searchList.value = keywordList.value.filter(item => item.choose == false && item.name.indexOf(
					keyword.value.replace(/\s+/g, ' ').trim()) > -1)
				for (var i in searchList.value) {
					var data = hilight_str(keyword.value.replace(/\s+/g, ' ').trim(), searchList.value[i].name);
					searchList.value[i]['searchName'] = data
				}
			}
			keyword.value = keyword.value.replace(/\s+/g, ' ')
		}
		const searchList = ref([])
		const toAdd = () => {
			if (keyword.value != '') {
				var reg = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]", 'gm')
				var key = keyword.value.replace(/\s+/g, ' ').trim().replace(reg, '|').split("|")
				for (var i in key) {
					if (key[i].replaceAll(' ', '') != '') {
						if (!keywordList.value.find(item => item.name == key[i].trim())) {
							var item = {
								name: key[i].trim(),
								choose: true,
								default: false,
							}
							keywordList.value.push(item)
							selectList.value.push(item)
						}
						else {
							if (key.length == 1 && keywordList.value.find(item => item.name == key[i].trim() && item.choose == true)) {
								message.warning('关键词已存在')
							}
							else if (!keywordList.value.find(item => item.name == key[i].trim() && item.choose == true)) {
								keywordList.value.find(item => item.name == key[i].trim()).choose = true
								selectList.value.push(keywordList.value.find(item => item.name == key[i].trim()))
								var index = noList.value.findIndex(item => item.name == key[i].trim())
								noList.value.splice(index, 1)
							}
							/*
								*/
						}
					}
				}
				edit.value = true
				keyword.value = ''
				searchList.value = []
			}
		}
		const toSubmit = () => {
			var parentCategoriesList = parentCategories.value.filter(item => item.checked == true)
			if (parentCategoriesList.length == 0) {
				message.warning('文章类别不能为空')
			}
			else if (selectList.value.length == 0) {
				message.warning('关键词不能为空')
			}
			else {
				var categoryIds = []
				for (var i in parentCategoriesList) {
					categoryIds.push(parentCategoriesList[i].id)
				}
				//每日汇总55
				categoryIds.push(55)
				categoryIds = categoryIds.toString().replaceAll(',', '|')
				var keyword = []
				var keywordListList = keywordList.value.filter(item => item.choose == true)
				for (var i in keywordListList) {
					keyword.push(keywordListList[i].name)
				}
				toPostSubmit(keyword, categoryIds)
			}
		},
			toPostSubmit = (keyword, categoryIds) => {
				reloading.value = true
				keyword = keyword.toString().replaceAll(',', '|')
				var list = {
					"companyId": store.getters.company.companyId,
					"keyword": keyword,
					"categoryIds": categoryIds
				}
				postSetMiniKeyword(list).then((res) => {
					reloading.value = false
					num.value = res.data
					visible.value = true
					edit.value = false
				})
			}
		const reloading = ref(false)
		const num = ref(0)
		const visible = ref(false)
		const afterClose = () => {
			visible.value = false
		}
		const iKnow = () => {
			visible.value = false
			store.dispatch("reloadFlag", true)
			store.dispatch("reloadINTFlag", true)
			router.push({ name: 'homePage' })
		}
		return {
			iKnow,
			afterClose,
			visible,
			num,
			reloading,
			toSubmit,
			toAdd,
			keyword,
			searchList,
			onInput,
			tagCategoryClick,
			tagClick,
			edit,
			selectList,
			noList,
			keywordList,
			parentCategories,
			childrenCategories,
			toGetKeyword,
			toSplitKeyword,
			scrollY,
			scrollView,
		}
	},
}
</script>
<style>
.tablestyle .ant-table-thead>tr>th,
.ant-table-tbody>tr>td {
	padding: 8px 8px !important;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.tablestyle {
	margin-top: 20px;
}

.scrollView {
	margin: 10px 0px;
}

.datelist {
	margin-left: 10px;
	display: inline-block;
}

.datelist a {
	margin-right: 10px;
}
</style>
<style scoped>
.searchView {
	position: absolute;
	z-index: 100;
	background: white;
	left: 0;
	width: 80%;
}


</style>
<style scope lang="scss">
.iconStyle {
	font-size: 32px;
	margin-right: 5px;

	&.success {
		color: green;
	}

	&.warning {
		color: orange;
	}
}

.mr20 {
	margin-top: 20px
}

.inputView {
	width: 20%;
	background: #2196F3;
	color: white;
	display: flex;
	min-height: 35px;
	align-items: center;
	justify-content: center;
}

.ubutton-class {
	padding: 0 10px !important;
	border: none !important;
	cursor: pointer;

	.u-hairline-border::after {
		border: none !important;
	}
}

.ubutton-class:hover {
	color: rgb(255 255 255) !important;
	background-color: #1890ff !important;
}

.subscribe {
	padding: 20upx;
	min-height: 100vh;
}

.custom-block {
	padding: .1rem .5rem;
	border-color: #00b2b9;
	border-left-width: .2rem;
	border-left-style: solid;
}

.footerButton {
	position: fixed;
	display: flex;
	width: 100%;
	justify-content: center;
	background: white;
	height: 50px;
	z-index: 100;
}</style>
